











































































# Import
import firebase from 'firebase/app'
import moment from 'moment'
import 'firebase/firestore'
import { user } from '../mapper'
import rounder from '../rounder.js'
      

# Export
export default
    data: -> 
        user: user
        events: []
        trash: false
        past: false
    mounted: ->
        this.$root.homeCallback = =>
            this.trash = false
            this.past = false
            this.fetch()
        auth = firebase.auth()
        auth.onAuthStateChanged (u) =>
            this.fetch()
    methods:
        moment: moment
        rounder: rounder
        fetch: ->
            comparison = if this.past then '<' else '>'
            sort = if this.trash or this.past then 'desc' else 'asc'
            ref = firebase.firestore().collection('events')
            .where('deleted', '==', this.trash)
            if not user.admin then ref = ref.where('hidden', '==', false)
            if not this.trash then ref = ref.where('date', comparison, new Date())
            ref.orderBy('date', sort)
            .onSnapshot (snap) =>
                this.events = []
                for doc in snap.docs
                    event = doc.data()
                    event.id = doc.id
                    this.events.push event
        open: (event) ->
            this.$router.push({name: 'event', params: {'alias': event.aliases[0]}})
        edit: (event) ->
            id = event?.id ? 'new'
            this.$router.push({name: 'edit', params: {'id': id}})
        showTrash: ->
            this.trash = true
            this.past = false
            this.fetch()
        showPast: ->
            this.trash = false
            this.past = true
            this.fetch()
